import React from "react";
import { Link } from "react-router-dom";
import "../css/Footer.css";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube, FaTwitter, FaTwitch } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* Kolonne 1: Brand */}
        <div className="footer-col brand">
          <p className="footer-tagline">
            Gaming • Fællesskab • Udvikling
          </p>

          <div className="footer-social">
            <a href="https://x.com/LinxLegacyACD" aria-label="X">
              <FaTwitter size={18} />
            </a>
            <a href="https://www.instagram.com/linxlegacy/" aria-label="Instagram">
              <FaInstagram size={18} />
            </a>
            <a href="https://www.twitch.tv/linxlegacy" aria-label="Twitch">
              <FaTwitch size={18} />
            </a>
            <a href="https://www.youtube.com/@linxlegacy" aria-label="YouTube">
              <FaYoutube size={18} />
            </a>
            <a href="https://www.facebook.com/61583910432471" aria-label="Facebook">
              <FaFacebook size={18} />
            </a>
            <a href="https://www.linkedin.com/company/110324958" aria-label="LinkedIn">
              <FaLinkedin size={18} />
            </a>
          </div>
        </div>

        {/* Kolonne 2: Hurtige links */}
        <div className="footer-col">
          <h4>Hurtige links</h4>
          <ul>
            <li><Link to="/">Academy</Link></li>
            <li><Link to="/omos">Om os</Link></li>
          </ul>
        </div>

        {/* Kolonne 3: Support */}
        <div className="footer-col">
          <h4>Om Linx Academy</h4>
        <ul>
          <li>
          <a href="/Terms">Brugeraftale</a>
          </li>
          <li>
          <a href="/Privatlivspolitik">Privatlivspolitik</a>
          </li>
          <li>
          <a href="/Betalingsbetingelser">Betalingsbetingelser</a>
          </li>
        </ul>
        </div>

        {/* Kolonne 4: Tom (kan bruges til nyhedsbrev senere) */}
        <div className="footer-col"></div>

      </div>

      {/* Copyright bar */}
      <div className="footer-bar">
        <p>© {new Date().getFullYear()} Linx Legacy - All rights reserved.</p>
      </div>
    </footer>
  );
}
